import { DefaultTheme } from "styled-components";
import bgImage from "../../assets/images/background.png";
import logoComTextoRoxa from "../../assets/images/logos/logo_com_texto_roxa.png";

export default {
  title: "default",

  colors: {
    primary: "#955fe1",
    secondary: "#25094c",
    chatMessage: "#9900f5",
    header: "",
    footer: "",
  },

  images: {
    // logo: "https://amplimedimggerais.s3-sa-east-1.amazonaws.com/Logo_novo.png",
    logo: logoComTextoRoxa,
    background: bgImage,
  },
} as DefaultTheme;
